import styled from "styled-components";
import ImgSlider from "./ImgSlider";
import NewDisney from "./NewDisney";
import Originals from "./Originals";
import Recommends from "./Recommends";
import Trending from "./Trending";
import Viewers from "./Viewers";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import db from "../firebase";
import { setMovies } from "../features/movie/movieSlice";
import { selectUserName } from "../features/user/userSlice";

const Anime = (props) => {
  const dispatch = useDispatch();
  const userName = useSelector(selectUserName);
  let anime_recommends = [];
  let animes_new = [];
  let anime_originals = [];
  let anime_trending = [];

  useEffect(() => {
    console.log("hello");
    db.collection("anime").onSnapshot((snapshot) => {
      snapshot.docs.map((doc) => {
        console.log("printing anime data=",doc.data().type);
        console.log(anime_recommends);
        switch (doc.data().type) {
          case "recommend":
            anime_recommends = [...anime_recommends, { id: doc.id, ...doc.data() }];
            break;

          case "new":
            animes_new = [...animes_new, { id: doc.id, ...doc.data() }];
            break;

          case "original":
            anime_originals = [...anime_originals, { id: doc.id, ...doc.data() }];
            break;

          case "trending":
            anime_trending = [...anime_trending, { id: doc.id, ...doc.data() }];
            break;
        }
      });

      dispatch(
        setMovies({
          recommend: anime_recommends,
          newDisney: animes_new,
          original: anime_originals,
          trending: anime_trending,
        })
      );
    });
  }, [userName]);

  return (
    <Container>
      <ImgSlider
        bgImage={{
          image_1: "./images/dc.jpeg",
          image_2: "./images/ac.jpeg",
          image_3: "./images/nc.jpeg",
          image_4: "./images/cc.jpeg",
        }}
      />
      <Viewers
        bgImage={{
          image_1: "./images/viewers-naruto5.png",
          image_2: "./images/viewers-aot.png",
          image_3: "./images/viewers-mha.png",
          image_4: "./images/viewers-code.png",
          image_5: "./images/demon.png",
          image_animation_1: "/videos/naruto.mp4",
          image_animation_2: "/videos/attackontitan.mp4",
          image_animation_3: "/videos/myHeroAcademia.mp4",
          image_animation_4: "/videos/code-geass.mp4",
          image_animation_5: "/videos/demonslayer.mp4",
        }}
      />
      <Recommends />
      <NewDisney />
      <Originals />
      <Trending />
    </Container>
  );
};

const Container = styled.main`
  position: relative;
  min-height: calc(100vh - 250px);
  overflow-x: hidden;
  display: block;
  top: 72px;
  padding: 0 calc(3.5vw + 5px);
  &:after {
    background: url("/images/home-background.png") center center / cover
      no-repeat fixed;
    content: "";
    position: absolute;
    inset: 0px;
    opacity: 1;
    z-index: -1;
  }
`;

export default Anime;
